import { HttpClient } from '@angular/common/http';
import { environment } from '@lohi/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { take } from 'rxjs/operators';

function getSANDiUrl() {
  let sandiUrl = 'https://dev.sand.shaleapps.com/lohi/';
  if (environment.api === 'https://api.lohi.ai') {
    sandiUrl = 'https://sand.shaleapps.com/lohi/';
  }
  return sandiUrl;
}

export function openSANDiBillingList(httpClient: HttpClient, logger: NGXLogger) {
  httpClient
    .get(`${environment.api}/v1/admin/sandi_billing_token`)
    .pipe(take(1))
    .subscribe(
      (response) => {
        window.open(getSANDiUrl() + response, '_blank');
      },
      (error) => {
        logger.error(error);
      },
    );
}

export function openSANDiBillingDetails(httpClient: HttpClient, logger: NGXLogger, loadId: string) {
  httpClient
    .get(`${environment.api}/v1/admin/sandi_billing_token`)
    .pipe(take(1))
    .subscribe(
      (response) => {
        window.open(getSANDiUrl() + response + '?loadId=' + loadId, '_blank');
      },
      (error) => {
        logger.error(error);
      },
    );
}
